import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IUpdateSettlementSummaryRequest } from '../models/settlement-summary-request.model';
import { ISettlementSummary } from '../models/settlement-summary.model';

@Injectable({
  providedIn: 'root',
})
export class SettlementSummaryApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.services.claims}/api/claims`;

  public getSettlementSummary(
    claimId: number
  ): Observable<ISettlementSummary[]> {
    return this.http.get<ISettlementSummary[]>(
      `${this.baseUrl}/${claimId}/settlement-summary`
    );
  }

  public updateSettlementSummary(
    claimId: number,
    body: IUpdateSettlementSummaryRequest
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${claimId}/settlement-summary`,
      body
    );
  }
}
